"use client";

export type VendorAssessmentListFilterKeywords = {
  productType?: string[];
  businessStatus?: string[];
  businessCategoryName?: string[];
  categoryManager?: string[];
  developer?: string[];
  vendor?: string[];
};

export type VendorAssessmentListSortOrder = "ASC" | "DESC";

export interface VendorAssessmentListRequest {
  pageNo: number;
  pageSize: number;
  search: string;
  sortBy?: string;
  sortOrder?: VendorAssessmentListSortOrder;
  filterKeywords: VendorAssessmentListFilterKeywords;
}

export interface VendorAssessmentVendorStatus {
  id?: number | string;
  vendorName?: string;
  vendorAssessmentStatus?: string;
  businessStatus?: string;
  /** API ingredient compliance — legacy `ingredientStatus` or list `subStatus` (e.g. Ingredient_Approved). */
  ingredientStatus?: string;
  subStatus?: string | null;
  published?: boolean | null;
  previousState?: string;
  vendorAssessmentId?: string;
  workflowStatus?: string[];
  typeOfVendor?: string;
  typeOfPackage?: string;
  retailStructure?: string;
  logistics?: string;
  manufacturingFacilityLocations?: string;
  shelfLife?: string;
  proposedRetail?: string;
  size?: string;
  packSize?: string;
  howManyFacilities?: string;
  reasonForDevelopment?: string;
}

export interface VendorAssessmentListItem {
  id: number | string;
  /** API `title` — normalized to `name` for grid display. */
  title?: string;
  name?: string;
  productType?: string;
  businessCategoryName?: string;
  category?: string;
  addedOn?: string;
  cancellationDate?: string | null;
  developer?: string;
  businessStatus?: string;
  subStatus?: string | null;
  sellingPeriod?: string;
  productSpecificationType?: string;
  categoryManager?: string;
  categoryManagerUser?: { id?: number | string; userName?: string };
  vendorList?: unknown;
  vendorStatus?: VendorAssessmentVendorStatus[];
  vendorStatuses?: string[];
  vendorCorporateName?: string[];
  vendorDetails?: Array<{ id?: number | string; vendorName?: string }>;
  [key: string]: unknown;
}

export interface VendorAssessmentListResponse {
  items: VendorAssessmentListItem[];
  totalCount?: number;
  pageNo?: number;
  pageSize?: number;
}

export const EMPTY_VENDOR_ASSESSMENT_LIST_FILTER_KEYWORDS: VendorAssessmentListFilterKeywords = {};

export function vendorAssessmentListHasAppliedQuery(
  filters: VendorAssessmentListFilterKeywords | null | undefined,
  search: string | null | undefined
): boolean {
  if ((search ?? "").trim().length > 0) return true;
  const f = filters ?? EMPTY_VENDOR_ASSESSMENT_LIST_FILTER_KEYWORDS;
  return (
    (f.productType?.length ?? 0) > 0 ||
    (f.businessStatus?.length ?? 0) > 0 ||
    (f.businessCategoryName?.length ?? 0) > 0 ||
    (f.categoryManager?.length ?? 0) > 0 ||
    (f.developer?.length ?? 0) > 0 ||
    (f.vendor?.length ?? 0) > 0
  );
}
